module.exports = __webpack_public_path__ + "assets/img/panda2.b5ac8ad6.png";